import React from 'react';
import { VersionEvent } from '../../../types';
export default function activeDetailStrategy() {
    return {
        appliesTo: (key) => key === 'active',
        render: (key, newValue, oldValue, versionEvent) => {
            // For Create events, just show the active status
            if (versionEvent === VersionEvent.Create) {
                const isActive = Boolean(newValue);
                return (React.createElement("span", { key: key },
                    "Status: ",
                    React.createElement("b", null, isActive ? 'Active' : 'Inactive')));
            }
            // For Update events, show the transition
            const wasActive = Boolean(oldValue);
            const isActive = Boolean(newValue);
            if (wasActive === isActive) {
                return React.createElement("span", { key: key },
                    "Status remains ",
                    isActive ? 'Active' : 'Inactive');
            }
            return (React.createElement("span", { key: key },
                "Changed from ",
                wasActive ? 'Active' : 'Inactive',
                " to ",
                isActive ? 'Active' : 'Inactive'));
        }
    };
}
